import { MetaObject } from '../../app/shared/interfaces/meta-object.interface'
import { environment } from '../../environments/environment'

export const metaDataContent: {
  [key: string]: MetaObject
} = {
  defaultMeta: {
    title: 'OECD AI Policy Observatory',
    description: '',
    path: ''
  },

  home: {
    title:
      'Observatoire OCDE des Politiques Publiques sur l’Intelligence Artificielle ',
    description:
      'OECD.AI est une plateforme permettant à ses utilisateurs de participer à la conception et la diffusion de politiques pour une IA responsable, digne de confiance qui soit au service de la société.',
    path: ''
  },

  principleList: {
    title: `'Les Principes sur l'Intelligence Artificielle (IA) de l'OCDE'`,
    description: `'Les Principes sur l'IA de l'OCDE encouragent l'utilisation de l'IA qui est innovante et digne de confiance et qui respecte les droits de l'Homme et les valeurs démocratiques. Ils établissent des normes à la fois pratiques et souples sur l’IA.'`,
    path: 'ai-principles'
  },

  OECDMetricsAndMethods: {
    title: 'Méthodes et mesures de l’IA de confiance employées à l’OCDE',
    description: `'L'OCDE a entamé des travaux méthodologiques visant à quantifier le développement de l'IA - cette section présente les publications officielles et les indicateurs utilisés par les comités de l'OCDE relatifs à la mesure de l'IA.'`,
    path: 'oecd-metrics-and-methods'
  },

  liveDataFromPartners: {
    title: 'Données en temps réels des partenaires de OECD.AI',
    description:
      'OECD.AI utilise des données en temps réel fournies par des partenaires externes afin de montrer des tendances actuelles sur les lieux, les manières et le rythme auquel l’IA est développée, utilisée et financée ainsi que ses secteurs d’application.',
    path: 'data'
  },

  countriesAndInitiatives: {
    title: 'OECD.AI Présentation de pays et initiatives',
    description:
      'Une base de données unique en son genre et interactive de politiques et initiatives en lien avec l’IA, régulièrement mise à jour.',
    path: 'countries-and-tools'
  },

  mainDashboard: {
    title:
      'Répertoire de plus de 300 stratégies et politiques publiques en lien avec l’IA de OECD.AI',
    description:
      'Cette section présente un répertoire d’information contenant plus de 300 stratégies et politiques publiques en lien avec l’IA dans 55 pays et l’Union Européenne.',
    path: 'dashboards'
  },

  about: {
    title:
      'A propos de l’Observatoire des Politiques Publiques sur l’Intelligence Artificielle de l’OCDE – OECD.AI',
    description:
      'OECD.AI combine les ressources de l’OECD avec celles de différents partenaires et groupes d’acteurs. Il apporte ainsi une analyse multidisciplinaire appuyée de faits réels ainsi que des données sur tous les différents domaines sur lesquels l’IA agit.',
    path: 'about'
  },

  networkOfExperts: {
    title: 'Le Réseau des Experts en IA de l’OCDE (ONE AI)',
    description:
      'Le Réseau des Experts en IA de l’OCDE (ONE.AI) apporte aux analyses de l’OCDE des contributions expertes issus des milieux politique, technique et des affaires et met en lumière des tendances.',
    path: 'network-of-experts'
  },

  survey: {
    title:
      'Survey : Practical use cases for implementation of the OECD AI Principles',
    description:
      'Please share your experience with us through this short survey on practical approaches and good practices to help AI actors and decision-makers to implement trustworthy AI systems.',
    path: 'survey'
  },
  classificationSurvey: {
    title: 'Survey for the classification of AI Systems',
    description:
      'Please share your experience with us through this short survey on the classification of AI systems.',
    path: 'survey'
  },

  resources: {
    title:
      'Liste de ressources par OECD.AI pour apprendre sur l’Intelligence Artificielle et ce qu’elle pleut accomplir',
    description: `'OECD.AI fournit cette liste de ressources pour aider les décideurs politiques et autres acteurs à en apprendre davantage sur l'intelligence artificielle, ce qu'elle peut faire et comment l'utiliser.'`,
    path: 'resources'
  },

  FAQ: {
    title: 'FAQ OECD.AI',
    description:
      'Cette section apporte des réponses à des questions fréquentes à propose de OECD.AI',
    path: 'faq'
  },

  wips: {
    title:
      'Programme de travail de OECD.AI sur le Travail, l’Innovation, la Productivité et les Compétences',
    description: `'Le programme OCDE.AI sur le Travail, l’Innovation, la Productivité et les Compétences (AI-WIPS) - dirigé et soutenu par l'Allemagne - analyse l'impact de l'IA sur le marché du travail, les compétences et la politique sociale, et formule des recommandations politiques.'`,
    path: 'work-innovation-productivity-skills'
  },

  policyInitiativeList: {
    title: 'Initiatives politiques',
    path: 'policy-initiatives'
  },

  search: {
    title: 'Recherche',
    path: 'search'
  },

  videos: {
    title: 'Vidéos',
    description: `'Les vidéos de l'OCDE AI'`,
    path: ''
  },

  // Blog.
  blogIndex: {
    title: 'The AI Wonk',
    path: 'wonk'
  },

  authorList: {
    title: 'AI Wonk contributors',
    path: 'wonk/contributors'
  },

  // AI Tool catalogue (EN only).
  toolCatalogOverview: {
    title: 'Catalogue of Tools & Metrics for Trustworthy AI',
    description:
      'An interactive collection of the latest tools and resources to help AI actors be accountable and ensure that AI systems and applications respect human rights and are fair, transparent, explainable, robust, secure and safe.',
    path: 'catalogue',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogToolList: {
    title: 'Tools for Trustworthy AI',
    path: 'catalogue/tools',
    description:
      'The OECD Catalogue of Tools & Metrics is for trustworthy AI systems and applications that respect human rights and are fair, transparent, explainable, robust, secure and safe. ',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogUseCaseList: {
    title: 'Use Cases from Tools or Trustworthy AI',
    path: 'catalogue/tool-use-cases',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogMetricList: {
    title: 'Metrics for Trustworthy AI',
    path: 'catalogue/metrics',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogMetricUseCaseList: {
    title: 'Metric Use Cases from Tools or Trustworthy AI',
    path: 'catalogue/metric-use-cases',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogToolSubmit: {
    title:
      'Submit an AI Tool to the Catalogue of Tools & Metrics for Trustworthy AI',
    path: 'catalogue/tools/submit',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogUseCaseSubmit: {
    title:
      'Submit a Use Case to the Catalogue of Tools & Metrics for Trustworthy AI',
    path: 'catalogue/tool-use-cases/submit',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogMetricSubmit: {
    title:
      'Submit a metric to the Catalogue of Tools & Metrics for Trustworthy AI',
    path: 'catalogue/tools/submit',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogMetricUseCaseSubmit: {
    title:
      'Submit a metric use case to the Catalogue of Tools & Metrics for Trustworthy AI',
    path: 'catalogue/tool-use-cases/submit',
    description:
      'These use cases share experiences and advice about AI tools in the OECD Catalogue of Tools & Metrics. Have you used a tool from the catalogue? Please share your experience.',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },
  toolCatalogAbout: {
    title: 'About the Catalogue of Tools & Metrics for Trustworthy AI',
    path: 'catalogue/about',
    absoluteOgImage:
      environment.baseUrl + 'assets/images/catalogue-og-image.png'
  },

  // Other.
  error404: {
    title: `Erreur 404: Page non trouvée - Observatoire des politiques d'IA de l'OCDE'`,
    description: `'Nous n'avons pas pu trouver la page que vous recherchez.'`,
    path: '404'
  }
}
